import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React, { Suspense } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from './config';
import PageNotFound from './Components/Pages/Pagenotfound';
import Home from './Components/Pages/Home';
import Home2 from './Components/Pages/Home2';
import Presale from './Components/Pages/Presale/Home';
import Aboutus from './Components/Pages/Aboutus';
import Privacypolicy from './Components/Pages/Privacypolicy';
//import UserLogin from './Components/Auth/Login';

// -------------------
import Dashboard from './Components/Pages/Presale/Dashboard';
import Swap from './Components/Dashboard/Swap';
import Liquiditypool from './Components/Dashboard/Liquiditypool';
import Addliquidity from './Components/Dashboard/Liquiditypool/Addliquidity';
import UserSignup from './Components/Auth/Signup';
import ScrollZoomText from './Components/Pages/scrollZoomText';
import Blog from './Components/Pages/Blog';
import Blogdetail from './Components/Pages/Blogdetail';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path={`${config.baseurl}home`} element={<Home2 />} />
          <Route path={`${config.baseurl}`} element={<Home2 />} />
          <Route path={`${config.baseurl}aboutus`} element={<Aboutus />} />
          <Route path={`${config.baseurl}blog`} element={<Blog />} />
          <Route
            path={`${config.baseurl}blogdetail/:idPrimary`}
            element={<Blogdetail />}
          />
          <Route
            path={`${config.baseurl}privacypolicy`}
            element={<Privacypolicy />}
          />

          <Route
            path={`${config.baseurl}about`}
            element={<h1>Welcome to about page</h1>}
          />

          {/* -------Presale live Starts----------- */}

          <Route path={`${config.baseurl}ico-old`} element={<Presale />} />
          {/* <Route path={`${config.baseurl}login`} element={<UserLogin />} />
          <Route path={`${config.baseurl}signup`} element={<UserSignup />} /> */}
          <Route path={`${config.baseurl}dashboard`} element={<Dashboard />} />

          {/* ---------Main Dashboard--------- */}
          <Route path={`${config.baseurl}swap`} element={<Swap />} />
          <Route
            path={`${config.baseurl}liquiditypool`}
            element={<Liquiditypool />}
          />
          <Route
            path={`${config.baseurl}addliquidity`}
            element={<Addliquidity />}
          />

          <Route
            path={`${config.baseurl}scrollZoomText`}
            element={<ScrollZoomText />}
          />

          <Route path={`/*`} element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
